// extensions.js - Расширения переводов

export default {
};